import analytics from '../../components/analytics/Analytics';
import segmentAnalytics from '../../components/analytics/SegmentAnalytics';
import ScoreStrip from '../../components/scorestrip/scorestrip';
import CountdownClock from '../../components/sidebar/CountdownClock';
import TopVideos from '../../components/sidebar/TopVideos.js';
import PromoBanner from '../../components/promo/promo';
import FsBeacon from '../../components/fs-beacon/FsBeacon';

window.FsBeacon = new FsBeacon();

// Set up sidebar components
var countdownClocks = document.querySelectorAll('.sidebar-component-countdown-clock');
if (countdownClocks.length > 0) {
    for (var i = 0, clockLen = countdownClocks.length; i < clockLen; i++) {
        new CountdownClock(countdownClocks[i]);
    }
}

new TopVideos();
//temporary for external access
//being used in big-board.js and marquee gallery

analytics.sendPageView();

if (document.getElementById('ScoresLink')) {
	let scorestrip = new ScoreStrip();
	
	if (document.querySelector('wis-scorestrip')) {
	    scorestrip.init();
	}
}

//object can be reused when importing this script
export default {
    'analytics': analytics,
	'segmentAnalytics': segmentAnalytics
}



// WEBPACK FOOTER //
// ./assets/layouts/base/base.js